export const NAV_ITEMS = [
  { path: "/", text: "Home", exact: true },
  //  { path: "/about", text: "About", exact: false },
  { path: "/aiva", text: "A.I.V.A.", exact: false },
  { path: "/embedful", text: "Embedful", exact: false },
  { path: "/resources", text: "Resources", exact: false },
  { path: "/contact", text: "Contact", exact: false },
];

export const PORT_FILTERS = [
  { name: "All", value: "all" },
  { name: "Open Source", value: "open-source" },
  { name: "Web", value: "web" },
  { name: "Rich Media", value: "rich-media" },
];

export const FOCUS_AREAS = [
  {
    icon: "fa-rocket",
    title: "SaaS Products",
    description:
      "From idea to production. Building, launching, and improving SaaS products across the full product lifecycle.",
  },
  {
    icon: "fa-magic",
    title: "AI & LLMs",
    description:
      "Practical integration of large language models, generative AI, automation, and AI-assisted workflows into real products.",
  },
  {
    icon: "fa-code",
    title: "Product Engineering",
    description:
      "Full-stack product development covering frontend, backend, architecture, infrastructure, and production deployment.",
  },
  {
    icon: "fa-users",
    title: "Technical Leadership",
    description:
      "Leading development teams, mentoring developers, making technical decisions, and guiding projects from concept to delivery.",
  },
];

export const LIFECYCLE_STAGES = [
  {
    number: "01",
    title: "Discover",
    icon: "fa-compass",
    description:
      "Product ideas, customer problems, requirements, product direction, and technical feasibility.",
  },
  {
    number: "02",
    title: "Build",
    icon: "fa-cubes",
    description:
      "SaaS applications, full-stack development, AI and LLM features, integrations, APIs, and data-driven functionality.",
  },
  {
    number: "03",
    title: "Launch",
    icon: "fa-rocket",
    description:
      "Infrastructure, deployment, CI/CD, authentication, billing, analytics, onboarding, and production readiness.",
  },
  {
    number: "04",
    title: "Grow",
    icon: "fa-line-chart",
    description:
      "Product iteration, automation, optimization, customer feedback, analytics, and continuous improvement.",
  },
];

export const TOOLS = [
  "TypeScript",
  "Elixir",
  "PostgreSQL",
  "n8n",
  "WordPress",
];

export const EMBEDFUL_STATS = [
  { label: "Monthly Revenue", value: "$84,240" },
  { label: "Active Customers", value: "2,418" },
  { label: "Retention", value: "96.4%" },
];

export const EMBEDFUL_FEATURES = [
  {
    step: "Connect",
    icon: "fa-plug",
    description:
      "Connect existing data from Postgres, MySQL, Firebase, Google Analytics, spreadsheets, or a custom API. Credentials are encrypted at rest and connections can be secured over SSL.",
  },
  {
    step: "Build",
    icon: "fa-bar-chart",
    description:
      "Use the visual builder to select tables, choose columns, and apply dynamic filtering. No SQL required. Assemble charts, tables, and counters into a responsive, auto-updating dashboard.",
  },
  {
    step: "Embed",
    icon: "fa-code",
    description:
      "Drop one dashboard configuration into your SaaS app, website, or customer portal. Each viewer gets a secure, short-lived token scoped to their own data, so one dashboard serves every customer.",
  },
];

export const EMBEDFUL_BENEFITS = [
  { value: "Minutes", label: "To Launch, Not Months" },
  { value: "1", label: "Dashboard To Maintain" },
  { value: "0", label: "Services To Deploy" },
  { value: "∞", label: "Customer Viewers" },
];

export const FAQ_ITEMS = [
  {
    question: "What does Fernan de Dios work on?",
    answer:
      "Fernan de Dios is a technical lead, consultant, product builder, and SaaS founder focused on building digital products, including Embedful, a customer-facing analytics platform, and AIVA, an agentic AI virtual assistant.",
  },
  {
    question: "What is Embedful?",
    answer:
      "Embedful is a SaaS platform that helps software teams build and embed secure, customer-facing analytics dashboards without having to create and maintain the underlying analytics infrastructure themselves.",
  },
  {
    question: "What is AIVA?",
    answer:
      "AIVA is an agentic AI virtual assistant designed to go beyond simple question-and-answer interactions by helping users perform tasks, follow workflows, and interact with connected tools and services.",
  },
  {
    question: "What is Fernan's background?",
    answer:
      "Fernan has more than two decades of experience in software development, technical leadership, web application development, and consultancy work. He now applies that experience to building, launching, and growing SaaS and AI products while continuing to work on selected consulting engagements.",
  },
  {
    question: "What kind of products does Fernan build?",
    answer:
      "Fernan builds SaaS products, AI-powered applications, and data-driven software, with a focus on taking products from idea and architecture through development, deployment, and launch.",
  },
  {
    question: "What kind of consulting work does Fernan do?",
    answer:
      "Fernan provides consulting in web and software development, technical architecture, product development, AI and LLM integration, and technical leadership, drawing on extensive experience across long-running consultancy and product development engagements.",
  },
  {
    question: "Does Fernan work with AI and LLMs?",
    answer:
      "Yes. Fernan works with artificial intelligence and large language models, integrating them into products, agentic workflows, automation, and practical user-facing features, including AIVA.",
  },
];

export const AIVA_FEATURES = [
  {
    icon: "fa-sliders",
    title: "Customize",
    description:
      "Design AIVA's tone, knowledge base, and workflows around your brand. Train it on your own docs, product content, and support history so every response sounds like you.",
  },
  {
    icon: "fa-graduation-cap",
    title: "Train",
    description:
      "AIVA improves from every conversation. Review conversation history, spot gaps, and refine its responses so it gets more accurate and more useful over time.",
  },
  {
    icon: "fa-plug",
    title: "Integrate",
    description:
      "Connect AIVA to the channels your customers already use, including website chat, Messenger, Slack, Discord, and Microsoft Teams, from a single configuration.",
  },
  {
    icon: "fa-bolt",
    title: "Act",
    description:
      "Give AIVA agentic capabilities: multi-step reasoning, tool calls, and handoffs across models, so it can complete tasks instead of just answering questions.",
  },
];

export const AIVA_INTEGRATIONS = [
  "Claude",
  "GPT-4",
  "OpenClaw",
  "Slack",
  "Discord",
  "Microsoft Teams",
  "Messenger",
  "Website Embed",
];

export const AIVA_FAQ_ITEMS = [
  {
    question: "What is AIVA?",
    answer:
      "AIVA (Artificially Intelligent Virtual Assistant) is an agentic AI assistant built by Fernan de Dios that combines large language models with tool use and multi-step reasoning, so it can hold brand-aligned conversations and take real actions across the channels your customers already use.",
  },
  {
    question: "What does \"agentic\" mean for AIVA?",
    answer:
      "Agentic means AIVA can go beyond answering questions: it can plan multi-step tasks, call tools and APIs, and hand work off between models, rather than only generating a single conversational reply.",
  },
  {
    question: "Does AIVA support OpenClaw?",
    answer:
      "Yes. AIVA is built to work alongside OpenClaw, an open-source, model-agnostic autonomous agent framework, so it can run agentic workflows locally and integrate with the messaging platforms OpenClaw supports.",
  },
  {
    question: "What platforms does AIVA integrate with?",
    answer:
      "AIVA can be embedded on your website and connected to messaging platforms such as Slack, Discord, Microsoft Teams, and Messenger, all from a single configuration.",
  },
  {
    question: "Is my data private with AIVA?",
    answer:
      "Yes. Vectorized data used to train and customize AIVA is stored in-house, so sensitive information stays within your organization.",
  },
];

export const EMBEDFUL_FAQ_ITEMS = [
  {
    question: "What is Embedful?",
    answer:
      "Embedful is a SaaS platform for building and embedding secure, customer-facing analytics dashboards, so SaaS teams can launch tenant-aware analytics without building the infrastructure themselves.",
  },
  {
    question: "What data sources does Embedful connect to?",
    answer:
      "Embedful connects to existing data sources including Postgres, MySQL, Firebase, Google Analytics, spreadsheets, and custom APIs, with credentials encrypted at rest and connections secured over SSL.",
  },
  {
    question: "Do I need to write SQL to build dashboards?",
    answer:
      "No. Embedful's visual builder lets you select tables, choose columns, and apply dynamic filtering without writing SQL, then assemble the result into charts, tables, and counters.",
  },
  {
    question: "How does Embedful keep customer data separate?",
    answer:
      "Each customer sees only their own data. Embedful maps viewers to secure, short-lived tokens scoped to their account, so one dashboard configuration can safely serve every customer.",
  },
  {
    question: "Where can I embed Embedful dashboards?",
    answer:
      "Dashboards can be embedded directly into your SaaS product, website, or customer portal, so customers see live analytics without leaving your app.",
  },
];

export const SELF_CERTS = [
  {
    title: "Hong Kong University of Science and Technology",
    img: "l_hk.png",
    url: "https://www.coursera.org/account/accomplishments/records/8B8T88HYHKAF",
  },
  {
    title: "John Hopkins University",
    img: "l_johnhopkins.png",
    url: "https://www.coursera.org/account/accomplishments/records/K72A9M8F3NSZ",
  },
  {
    title: "University of London",
    img: "l_ul.png",
    url: "https://www.coursera.org/account/accomplishments/records/PKS4XBgD3fwV8z6G",
  },
  {
    title: "DoubleClick Studio",
    img: "l_dc.png",
    url: "http://www.richmediagallery.com/tools/certified-users#certifiedUser:4764~",
  },
  {
    title: "Mediamind",
    img: "l_mm.png",
    url: "http://demo.mediamind.com/Training_Zone/certificates/146599.pdf",
  },
  {
    title: "Informatics",
    img: "l_info.png",
    url: "http://www.fernandedios.com/certs/informatics.pdf",
  },
];

export const API_URL = "https://aiva-api.herokuapp.com";

export const FOOTER_LINKS = [
  {
    title: "Navigate",
    set: [
      { path: "/", text: "About" },
      { path: "/aiva", text: "AIVA" },
      { path: "/embedful", text: "Embedful" },
      { path: "/resources", text: "Resources" },
      { path: "/contact", text: "Contact" },
    ],
  },
];

export const SOCIALS = [
  {
    title: "GitHub",
    icon: "fa fa-github-alt",
    url: "https://github.com/fernandedios",
  },
  {
    title: "LinkedIn",
    icon: "fa fa-linkedin-square",
    url: "https://www.linkedin.com/in/fernan-de-dios-56b1313b/",
  },
  {
    title: "X",
    icon: "fa fa-twitter",
    url: "https://twitter.com/fernan_de_dios",
  },
];
